export default __webpack_public_path__ + "static/media/category_black_24dp.e66413ae.svg";